import { render, staticRenderFns } from "./biography.vue?vue&type=template&id=3ca64d97&scoped=true"
import script from "./biography.vue?vue&type=script&lang=js"
export * from "./biography.vue?vue&type=script&lang=js"
import style0 from "./biography.vue?vue&type=style&index=0&id=3ca64d97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca64d97",
  null
  
)

export default component.exports